<template>
	<div>
		<core-layout-content
			v-if="!['asia_uat', 'asia'].includes($store.state.tenantId)"
			medium
		>
			<core-layout-headline-and-actions>
				<template slot="headline">{{ $t("create_case") }}</template>
			</core-layout-headline-and-actions>

			<!-- Body -->
			<j-card class="xs-12 bg5 r2 p4">
				<!-- Template -->
				<div class="xs-12">
					<label for="type" class="lh125 mb1 fw7">
						<!-- {{ $t("select_template_for_this_case") }} -->
						{{ $t("select_product") }}
					</label>
					<j-base-select
						:options="options.components"
						v-model="form.componentId"
						nameKey="name"
						valueKey="id"
					/>
				</div>

				<!-- Buttons -->
				<div class="mt6">
					<j-button
						:isLoading="isLoading"
						@click="handleSubmit"
						v-if="form.componentId"
						>{{ $t("create") }}</j-button
					>
				</div>
			</j-card>
		</core-layout-content>
		<asia-case-management-create
			v-if="['asia_uat', 'asia'].includes($store.state.tenantId)"
		/>
	</div>
</template>

<script>
import JCard from "@/components/JCard/"
import JBaseSelect from "@/components/JBaseSelect/"
import JButton from "@/components/JButton/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import AsiaCaseManagementCreate from "../components/mockedAsia/AsiaCaseManagementCreate.vue"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import get from "lodash.get"

export default {
	components: {
		JCard,
		JBaseSelect,
		JButton,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		AsiaCaseManagementCreate
	},

	data() {
		return {
			isLoading: false,

			options: {
				components: [
					// { name: "JB", value: "ck3y5alzl002f01x56hyi1uv8" }
				]
			},

			form: {
				componentId: ""
			}
		}
	},

	methods: {
		async fetchCaseComponents() {
			// TODO: this should fetch only components for case template
			const query = gql`
				query caseComponents($where: componentWhereInput) {
					components(where: $where) {
						list {
							id
							name
						}
					}
				}
			`

			const res = await api({ query, variables: {} })
			this.options.components =
				res?.data?.components?.list?.map(item => ({
					...item,
					// HACK:
					// Sorry, under pressure and no time
					// show only product name and not "Case"
					// This was done for Berkley demo but can be removed after 22nd Jan 2020
					// Correc approach is to rename the component itself but that could break some other stuff
					name: item.name.replace("Case", "")
				})) || []
		},

		async handleSubmit() {
			const query = gql`
				mutation createCase($input: createCaseInput!) {
					createCase(input: $input) {
						errors
						status
						createdStatus {
							id
						}
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: { input: { componentId: this.form.componentId } }
			})
			this.isLoading = false

			// Don't check errors, just redirect to detail page
			this.$router.push({
				name: "CaseManagementDetail",
				params: { id: res?.data?.createCase?.createdStatus?.id }
			})
		}
	},

	created() {
		// Populate case templates
		this.fetchCaseComponents()
	}
}
</script>
